"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigationTypeOptions = exports.getKeyForIdentifierLabel = exports.getEndpointsForTypes = exports.directLinkTypeOptions = void 0;

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NAVIGATION_TYPES = ['Category', 'Page', 'Article', 'Article Category', 'Direct Link', 'Branch'];
var navigationTypeOptions = NAVIGATION_TYPES.map(function (n) {
  return {
    label: n,
    value: n === 'Page' ? 'content' : (0, _camelCase["default"])(n)
  };
});
exports.navigationTypeOptions = navigationTypeOptions;
var directLinkTypeOptions = [{
  label: 'Internal',
  value: 'internal'
}, {
  label: 'External',
  value: 'external'
}];
exports.directLinkTypeOptions = directLinkTypeOptions;

var getEndpointsForTypes = function getEndpointsForTypes(type) {
  var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var types = {
    category: {
      endpoint: 'categories',
      params: {
        id: 'categories',
        filter: {
          heading: input,
          status: 'active'
        }
      }
    },
    article: {
      endpoint: 'contents',
      params: {
        id: 'contents',
        filter: {
          type: 'article',
          name: input
        }
      }
    },
    content: {
      endpoint: 'contents',
      params: {
        id: 'contents',
        filter: {
          type: 'page',
          name: input
        }
      }
    },
    articleCategory: {
      endpoint: 'article-categories',
      params: {
        id: 'article-categories',
        filter: {
          name: input
        }
      }
    }
  };
  return types[type];
};

exports.getEndpointsForTypes = getEndpointsForTypes;

var getKeyForIdentifierLabel = function getKeyForIdentifierLabel(type) {
  switch (type) {
    case 'category':
      return 'heading';

    default:
      return 'name';
  }
};

exports.getKeyForIdentifierLabel = getKeyForIdentifierLabel;